<div class="select-visit-slot mb-5 gx-0"
     *ngIf="loadedWeeksTotalCount">
  <div class="d-flex justify-content-center flex-nowrap py-2 px-0 my-3"
       *ngIf="loadedWeeksTotalCount">

    <ng-container *ngIf="availableVisitSlots.length">
      <button type="button"
              class="btn-next-week btn btn-link fw-bolder pe-md-2 m-0 col-auto"
              (click)="loadPreviousWeek()"
              [disabled]="disabledArrowButton">
        <i-feather name="arrow-left-circle"></i-feather>
      </button>

      <ngb-pagination [collectionSize]="70"
                      (pageChange)="onPageChange($event)"
                      [(page)]="parentForm.controls.daySlotItem.value"
                      [directionLinks]="false"
                      class="custom-pagination-class overflow-x-scroll-mobile p-0 col-auto non-clickable">
        <ng-template ngbPaginationNumber
                     let-p>
          <div class="d-flex flex-column justify-content-around align-items-center py-0 px-1 px-sm-3 px-md-4 py-sm-1 py-md-2 clickable-item border rounded-1 col-auto"
               [ngClass]="{'notAvailableDay':!availableVisitSlots[p-1]?.slots.length}"
               (click)="setActiveItem(p)">
            <div>
              <span class="fs-6 mb-0 mt-4 text-center text-sm-start">
                {{ getWeekDayKey(p) | weekDayKeyFromDate | translate }}</span>
            </div>
            <div><span class="fs-4">{{ getDay(p) }}</span></div>
            <div class="fs-6">{{ getMonth(p) | monthNameKeyFromDate | translate }}</div>
          </div>
        </ng-template>
      </ngb-pagination>

      <button type="button"
              class="btn-next-week btn btn-link fw-bolder ps-md-2 m-0 col-auto"
              (click)="loadNextWeek()">
        <i-feather name="arrow-right-circle"></i-feather>
      </button>
    </ng-container>

  </div>
  <div *ngIf="slotsForOneDay?.length > 0 && hasAnySlotsForThisWeek">
    <div class="dvi-themed-content-container row py-2 px-1 px-md-5 mt-3">
      <div class="col-6 col-sm-3 px-2 d-grid"
           *ngFor="let visitSlot of slotsForOneDay">
        <button type="button"
                class="btn dvi-choose-visit-btn-themed fw-bolder my-2 py-2"
                (click)="visitSlotSelected(visitSlot)">
          {{ visitSlot.startDate | date: 'HH:mm' }}
        </button>
      </div>
    </div>
  </div>
  <div class="card mx-md-5"
       *ngIf="!slotsForOneDay?.length && hasAnySlotsForThisWeek">
    <div class="card-body fw-bold">
      <span class="fw-bold h5 text-secondary d-block"
            [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.NO-VACANCIES-PER-DAY'"></span>
    </div>
  </div>
  <div class="card mx-md-5"
       *ngIf="!hasAnySlotsForThisWeek && !hasNoSlotsForConsecutive30Days">
    <div class="card-body fw-bold">
      <span class="fw-bold h5 text-secondary d-block"
            [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.NO-VACANCIES-THIS-WEEK.TEXT'"></span>
      <span class="card-text d-block">
        <a href="#"
           (click)="searchForFirstAvailableTimeSlots(); false"
           [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.NO-VACANCIES-THIS-WEEK.OPTION-ONE'">
        </a>
        <ng-container>
          <span class="text-secondary px-1"
                [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.NO-VACANCIES-THIS-WEEK.OR'"></span>
          <a href="#"
             (click)="changeSpecialist(); false"
             [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.NO-VACANCIES-THIS-WEEK.OPTION-TWO'">
          </a>
        </ng-container>
      </span>
    </div>
  </div>
  <div class="card mx-md-5"
       *ngIf="hasNoSlotsForConsecutive30Days">
    <div class="card-body fw-bold">
      <span class="fw-bold h5 text-secondary d-block"
            [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.NO-VACANCIES-THIS-MONTH.TEXT'"></span>
      <span class="card-text text-secondary d-block">
        <a href="#"
           (click)="changeSpecialist(); false"
           [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.NO-VACANCIES-THIS-MONTH.OPTION'">
        </a>
      </span>
    </div>
  </div>
</div>
